module.exports = __webpack_public_path__ + "static/media/multi-channel-views.0eeba847.svg";